import { KeywordMapping } from './htmlParserCombined';
import { createApplyButton } from '../components/ApplyButton';

export const placeKeywordMappings: KeywordMapping[] = [
  {
    keyword: '[[applyNowButton]]',
    component: createApplyButton,
    props: {inline: false},
  },
];